import Library from '@/views/library'
import List from '@/views/library/list'
import Document from '@/views/library/document'
import Restore from '@/views/library/restore'

export default {
  path: 'libraries',
  name: 'library.library',
  component: Library,
  redirect: 'libraries/media',
  children: [
    {
      path: 'media',
      name: 'library.media',
      component: List
    },
    {
      path: 'documents',
      name: 'library.document',
      component: Document
    },
    {
      path: 'trash',
      name: 'trash.trash',
      component: Restore
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/library/library.js